import React, { useRef, useState } from 'react'
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import UploadIcon from "@mui/icons-material/Upload";

function NewsExternalForm({handleSubmit,handleChange,form,okayToSubmit}) {

    const [imageTabIndex,setImageTabIndex]= useState(0)
    const [uploadingImage,setUploadingImage]=useState(false)
    const fileInputRef = useRef(null);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          // Convert to local preview URL
        //   const previewUrl = URL.createObjectURL(file);
        //   setContent((prev) => ({ ...prev, value: previewUrl }));
          
          const formData = new FormData();
          formData.append("image", file);
          setUploadingImage(true)
          try{
            // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
            // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
              const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
              // const res = await fetch("/cms/ftp-files/", {
              method: "POST",
              body: formData, // don't add headers here
            });
          // console.log(res)
          if(res?.status===201){
            let result = await res.json()
            // console.log("Upload urls: ",result)
            e = {target:{name:"image",value:result?.path}}
            handleChange(e);
            setUploadingImage(false)
          // setMaterialUrl(event,event.target.value)
            // setUploadUrls(prev=>res?.data)
            // setConstFileUpload(false)
          }else{
            console.log(res)
          }
          }catch(error){
            console.log(error)
          }
      
          }
      }
    
  return (
    <div>
        <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
            <i>Required fields are marked with an asterisk (*).</i>
  
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={form.title}
                onChange={handleChange}
                margin="normal"
                required
                
              />

            <TextField
                fullWidth
                label="Subtitle"
                name="subtitle"
                value={form.subtitle}
                onChange={handleChange}
                margin="normal"
                required
                
              />
  
              
              <Typography variant='p' component="p" color='#404040'>
              Write a brief summary statement on you view about this article/news.
              </Typography>
             
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={form.description}
                onChange={handleChange}
                margin="normal"
                required
                multiline
                rows={4}
              />

            <TextField
                fullWidth
                label="Link of story/article"
                name="link"
                value={form.link}
                onChange={handleChange}
                margin="normal"
                required
                
              />

              <>
              <Tabs
                value={imageTabIndex}
                onChange={(e, newValue) => setImageTabIndex(newValue)}
                centered
                sx={{ mb: 1 }}
              >
                <Tab label="Image Representation Link" />
                <Tab label="Upload Value Image Representation" />
              </Tabs>

              {imageTabIndex === 0 ? (
                <TextField
                  name="image"
                  label="image Link"
                  value={form?.image}
                  onChange={handleChange}
                  fullWidth
                />
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  {form?.image ? (
                    form?.image?.length >= 0 ? (
                      <img
                        src={form?.image}
                        alt="preview"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        File selected: {form?.image.split("/").pop()}
                      </Typography>
                    )
                  ) : (
                    <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                  )}

                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    loading ={uploadingImage}
                  >
                    {form.image ? "Click Change File" : "Click to Upload File"}
                  </Button>
                  <input
                    type="file"
                    accept={"image/*"}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              )}
            </>
  
              {/* <SubCategorySelect setCategoryId={handleChangeCategory } setSubCategoryId={handleChangeSubCategory } /> */}
              {/* <TextField
                fullWidth
                label="Organisation tag Name"
                name="org_tag"
                value={form.subcategory}
                onChange={handleChange}
                margin="normal"
                required
              /> */}
  
              {/* <TextField
                fullWidth
                label="Organisation tag Name"
                name="org_tag"
                value={form.category}
                onChange={handleChange}
                margin="normal"
                required
              /> */}
              
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 1 ,mb:5}}
                disabled={okayToSubmit}
              >
                Create Article
              </Button>
            </form>
    </div>
  )
}

export default NewsExternalForm